<template>
  <div>
    <K-Loading :Loading="Loading"></K-Loading>
  </div>
</template>

<script>
var self;
import axios from 'axios'
import Loading from '@/components/Loading.vue'
export default {
  name: 'Transition',
  components: {
    'K-Loading': Loading
  },
  data () {
    return {
      Loading:{
        type:1,
        txt:"数据请求中..."
      }
    }
  },
  created () {
    self = this;
    self.VersionCheck(); //版本检测
    if(this.$route.query.tid && this.$route.query.tname && this.$route.query.pid && this.$route.query.rid){
      let tid = this.$route.query.tid;
      let pid = this.$route.query.pid;
      let rid = this.$route.query.rid;
      let tname = this.$route.query.tname;
      this.$router.push({path: "/"+tname,query: {type:"demo",tid:tid,pid:pid,rid:rid}}); //demo查询
    }else{ //真实查询
      let code = self.GetCode();
      if(code){
        self.GetCodeInfo(code);
      }else{
        this.Loading.type = 3;
        this.Loading.txt = "码标错误"
        this.showLoading = true;
      }
    }
  },
  methods:{
    GetCodeInfo (code) {
      axios.get(self.GetServerUrl(1)+"query/"+code+"/init")
      .then(function (response){
        let datas = response.data.meta;
        if(datas){
          datas.business && localStorage.setItem("wwmxt_Rootid", datas.business.rootid);
          localStorage.setItem("wwm_template_name", datas.id);

          //特殊拦截
          //if(['100010077'].includes(datas.business.rootid)){
          //  self.Loading.type = 3;
          //  self.Loading.txt = "此码已过期，请联系管理员！"
          //  return;
          //}

          if(datas.id == "Market"){ //促销
            window.location.href = "https://sale.oid.plus/x?"+code;
          }else{
            if(datas.org.origin){ //拥有组织的查询
              const excludeBusiness = ['100800002'];
              localStorage.setItem("wwm_business",JSON.stringify(datas.business));
              localStorage.setItem("wwm_origin",JSON.stringify(datas.org));
              let origin = JSON.parse(datas.org.origin);
              if(origin && origin.template.state == 1 && !excludeBusiness.includes(datas.business.rootid)){ //OID菜单
                self.$router.push({path: "/Org"});
              }else{
                if(datas.org.rootid == 1004){  //滑县烧鸡
                  //禁用查询
                  // self.Loading.type = 3;
                  // self.Loading.txt = "您查询的编码暂时无法使用，请联系管理员！";

                  self.$router.push({path: "/Normal05"}); // 默认模板
                }else{
                  if(datas.id){
                    self.$router.push({path: "/"+datas.id}); // 模板路由跳转
                  }else{
                    self.$router.push({path: "/Normal01"}); // 默认模板
                  }
                }
              }
            }else{

              //ITO艾特柔定制模版
              const params = self.GetParams();
              if(datas.business.rootid === '100010256'){
                if(params.source === 'customScan'){
                  self.$router.push({path: "/Normal16"});
                }else{
                  window.location.href = `https://sale.oid.plus/x/ito.html?${code}`
                }
                return;
              }

              //卢修斯定制模版
              if(['100010304', '100010370'].includes(datas.business.rootid)){
                self.$router.push({path: "/lxs"});
                return;
              }

              //嘉祥民安定制模版
              if(['100010348'].includes(datas.business.rootid)){
                self.$router.push({path: "/Normal24"});
                return;
              }

              //老人头私有模版、从公众号扫码进入 && params.source === 'customScan'
              if(datas.business.rootid === '100010110'){
                self.$router.push({path: "/Mobile"});
                return;
              }

              //上海峰文商贸有限公司私有模版
              if(datas.business.rootid === '100010158'){
                self.$router.push({path: "/Normal14"});
                return;
              }

              //根据模版ID选择跳转
              if(datas.id){
                 //特殊情况，当二维码是农药行业且默认模版是普通模版默认
                if(code.length == 32 && (datas.id == 1 || datas.id == 'Normal01')){
                  self.$router.push({path: "/Pesticide01"}); //跳转至农药默认
                }else{
                  self.$router.push({path: "/"+datas.id}); //正常跳转
                }
              }else{ //没有选择过模版的商品，根据行业跳转到默认的模版
                if(code.length == 32){ //农药行业
                  self.$router.push({path: "/Pesticide01"}); // 默认模板
                }else{ //普通行业
                  self.$router.push({path: "/Normal01"}); // 默认模板
                }
              }
            }
          }
        }else{
          let template = "Normal01";
          if(code.length == 32){
            template = "Pesticide01"
          }
          self.$router.push({path: "/"+template}); // 模板路由跳转
        }
        console.log(datas)
      }).catch(function (error){
        console.log(error)
        self.showLoading = true;
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    VersionCheck () {
      axios({
        method: 'get',
        url: self.GetServerUrl(1) +"app_version",
      }).then(function(res) {
        var json = res.data;
        if(json.code == 200){
          var datas = JSON.parse(json.meta);
          if(datas.version != localStorage.getItem("wwm_Version")){
            localStorage.setItem("wwm_Version",datas.version);
            window.location.reload(true);
          }
        }
      }).catch(function(error) {
        console.log(error);
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/public-view/Transition.vue